import {createAction, props} from '@ngrx/store';
import {LoadingType} from '@common/_models/core.models';
import {HttpErrorResponse} from '@angular/common/http';
import {TruckLocationModel} from '../../../../../services/broker/model/truckLocationModel';
import {TruckLocationRequest} from '../../../../../services/broker/model/truckLocationRequest';

export const LoadList = createAction(
    '[Unit map] Load List',
    props<{ payload: { loading?: LoadingType, clearState?: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Unit map] Load List Success',
    props<{ payload: { items: TruckLocationModel[], clearState?: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Unit map] Load List Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);

export const SetFilter = createAction(
    '[Unit map] Set Filter',
    props<{ payload: { filter?: TruckLocationRequest } }>()
);

export const SetListLoading = createAction(
    '[Unit map] Set List Loading',
    props<{ payload: { loading: LoadingType } }>()
);

export const SetInitialState = createAction(
    '[Unit map] Set Initial State'
);
